import {createApp} from 'vue'
import App from './App.vue'
import {createPinia} from "pinia"
import {router} from "./router/index";

//import VConsole from "vconsole";
//new VConsole();

/* 单独的样式 */
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';

import batch____import from './utils/auto_import'
import goto____bootstrap from "./utils/bootstrap";

// 根据mock模式决定是否加载mock数据
import system from './stores/system';
console.log('当前系统模式:', system.isMockMode);

// 直接导入mock，无论什么模式都加载，让Mock根据URL参数决定是否启用
import './mock';
console.log('Mock模块已导入');


/* 初始化vue */
let app = createApp(App);
app.use(createPinia());//状态管理器
app.use(router);//路由加载

// 在应用启动后输出当前模式信息
router.isReady().then(() => {
    console.log('应用已启动');
    console.log('当前模式:', system.isMockMode ? 'Mock模式' : '生产模式');
    console.log('调试模式:', system.debug ? '开启' : '关闭');
});

batch____import(app);//批量导入组件
goto____bootstrap(); //引导系统初始化

app.mount('#app')
